var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f624bec3be0f99fcdcb191ff7512eab6.js').default;export default
        Object.assign({}, scope_0 )
    